<template>
    <footer>
        <!-- 粤公网安备 -->
        <div class="netSafe">
            <img src="../../assets/images/logo.png" alt="" class="icon">
            <div class="text" @click="navigateTo($event, 'netSafe')">粤公网安备 44011302000935号</div>
        </div>

        <!-- 版权声明 -->
        <div class="copyright">
            <div class="title">版权声明</div>
            <div class="content">
                <span>版权所有© 广州市气象台</span>
                <span @click="navigateTo($event, 'icp')" class="icp">粤ICP备 06082644号</span>
                <span>Copyright(C) 2017-2019</span>
                <span>by Guangzhou Meteorological Service All Rights Reserved</span>                
            </div>
        </div>

        <div class="contactUs">
            <div class="title">联系我们</div>
            <div class="content">
                <span>广州市番禺区大石植村工业一路68号</span>
                <span>天气咨询：12121</span>
                <span>联系电话：020-66619588</span>
                <span>传真：020-66619585</span>                
            </div>
        </div>

        <div class="subscribe">
            <div class="title">关注我们</div>
            <div class="content">
              <img src="../../assets/images/wxm.png" alt="">  
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    methods: {
        navigateTo($event, str) {
            if(str == 'netSafe') {
                window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011302000935')
            }else if(str == 'icp') {
                window.open('https://beian.miit.gov.cn/#/Integrated/index')
            }
        } 
    }
}
</script>

<style lang="less">
    footer {
        display: flex;
        justify-content: space-evenly;
        width: 100%;
        padding: 20px 0;
        margin-top: 20px;
        background-color: #B16535;
        line-height: 30px;
        .netSafe {
            height: 100%;
            color: #ccc;
            font-size: 14px;
            text-align: center;
            .text {
               cursor: pointer; 
            }
        }
        .copyright,
        .contactUs,
        .subscribe {
            .title {
                color: white;
                font-size: 14px;
            }
            .content {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                border-top: 1px solid #ccc;
                font-size: 12px;
                color: #ccc;
                .icp {
                    cursor: pointer;
                }
            }
        }

        .subscribe {
            .title {
                text-align: center;
            }
        }
    }
</style>